export default __webpack_public_path__ + "static/media/icon_plus.8597c154.svg";